import { render, staticRenderFns } from "./JoszakiDataTableFilterPill.vue?vue&type=template&id=db700298"
import script from "./JoszakiDataTableFilterPill.vue?vue&type=script&lang=js"
export * from "./JoszakiDataTableFilterPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports